// game/utility.js - Constantes y funciones de utilidad

// Constantes para el tamaño de la pantalla y los tiles
export const WIDTH = 960;
export const HEIGHT = 960;
export const GS = 32; // Grid Size (tamaño de celda)

// Constantes para direcciones
export const DOWN = 0;
export const LEFT = 1;
export const RIGHT = 2;
export const UP = 3;

// Función de división para calcular coordenadas de celda
export function div(a, b) {
    return Math.floor(a / b);
}

// Función para calcular el desplazamiento (offset) del mapa
export function calcOffset() {
    // Actualmente devuelve [0, 0] pero podría modificarse para seguir al jugador
    return [0, 0];
}